import * as React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { INonPaidActivity } from "../../../../model/report/applicantdata/NonPaidActivity";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const PDFExportNonPaidActivity = ({
  translate,
  data
}: {
  translate?: any;
  data?: INonPaidActivity[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <View>
      <View style={styles.titleCol}>
        <Text style={styles.header}>
          {translate("report8.document_template.non_paid_activities.title")}
        </Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate("report8.document_template.non_paid_activities.name")}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.non_paid_activities.activity_type"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.non_paid_activities.activity_source"
              )}
            </Text>
          </View>
          <View style={styles.tableDateCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.non_paid_activities.date_from"
              )}
            </Text>
          </View>
          <View style={styles.tableDateCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.non_paid_activities.date_to"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.non_paid_activities.description"
              )}
            </Text>
          </View>
        </View>
        {data?.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.activityType}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.legalOrNatualEntity}</Text>
            </View>
            <View style={styles.tableDateCol}>
              <Text style={styles.tableCell}>{item.dateFrom} </Text>
            </View>
            <View style={styles.tableDateCol}>
              <Text style={styles.tableCell}>{item.dateTo}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.description} </Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PDFExportNonPaidActivity;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});


const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "10pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "12pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginBottom: 20,
    marginLeft: 5
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "19%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableDateCol: {
    width: "12%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 8,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  }
});
